<div class="login-page" role="main" aria-label="Login page">
    <div class="loginWrapper">
        <div class="login-card">

            <div class="formWrapper">
                <h3 class="title" [appTranslate]="'LOG_IN'"></h3>
                <p class="loginDescription" [appTranslate]="'LOGIN_DESCRIPTION'"></p>
                <div class="form-group">
                    <label for="login-email" [appTranslate]="'EMAIL'"></label>
                    <input id="login-email" type="email" class="form-control" name="email"
                        [(ngModel)]="loginModel.Email" aria-describedby="login-email-errors" (keyup.enter)="login()">
                    <div id="login-email-errors" class="errors error-messages" *ngIf="errors"><app-error
                            [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error></div>
                </div>

                <div class="form-group">
                    <label for="login-password" [appTranslate]="'PASSWORD'"></label>
                    <input id="login-password" type="password" class="form-control" name="password"
                        [(ngModel)]="loginModel.Password" aria-describedby="login-password-errors"
                        (keyup.enter)="login()">
                    <div class="rememberMeFlex">
                        <div id="login-password-errors" class="errors error-messages" *ngIf="errors"><app-error
                                [errors]="errors" [ErrorKey]="'Password'" class="error-feedback"></app-error></div>
                        <div class="rememberMe">
                            <mat-slide-toggle [(ngModel)]="rememberMe"><span
                                    [appTranslate]="'REMEMBER_ME'"></span></mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <div class="loginBtn">

                    <button type="button" class="btn-primary" (click)="login()"><span
                            [appTranslate]="'LOG_IN'"></span></button>

                    <div class="notRegWrap">
                        <span [appTranslate]="'CONTINUE_WITH'"> </span>
                        <div class="social-btn-div">
                            <asl-google-signin-button type='icon' size='large'
                                text='continue_with'></asl-google-signin-button>
                            <button type="button" class="fb-btn" (click)="signInWithFacebook()">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="#ffffff">
                                    <path
                                        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="notRegWrap">
                        <span class="login_reg" [appTranslate]="'NOT_REGISTER'"></span>
                        <button type="button" class="btn-link" (click)="register()"><span
                                [appTranslate]="'REGISTER'"></span></button>
                    </div>
                </div>
                <div class="forgotPsw">
                    <a type="button" class="btn-forgot" (click)="forgot()"><span
                            [appTranslate]="'FORGOT_PASSWORD'"></span></a>
                </div>
                <div class="errors error-messages errorReason" *ngIf="errors"><app-error [errors]="errors"
                        [ErrorKey]="''" class="mainErrorReason"></app-error>
                </div>
            </div>


        </div>
    </div>
    <div class="loader" *ngIf="myLoaderService.isLoading | async"></div>
</div>